import { useState, useEffect } from 'react';
import apiService from '../services/apiService';

const useSubscriptions = (currentPage = 1, currentPageLimit = 100, refreshKey) => {
  const [subscriptions, setSubscriptions] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSubscriptions = async () => {
      setLoading(true);
      try {
        const response = await apiService.getSubscriptions(currentPage, currentPageLimit);
        const data = response?.data || response;
        const { items = [], total_pages = 1, total_items = 0 } = data;
        setSubscriptions(items || []);
        setTotalPages(total_pages || 1);
        setTotalItems(total_items || 0);
        setError(null);
      } catch (err) {
        console.error(err);
        setError(err.message || 'Error fetching subscriptions');
      } finally {
        setLoading(false);
      }
    };
    fetchSubscriptions();
  }, [currentPage, currentPageLimit, refreshKey]);

  return { subscriptions, totalPages, totalItems, loading, error };
};

export default useSubscriptions;
